import { trackEvent } from '@/entities/sogu';
import { computed, watch } from 'vue';
import { useBootstrapExperiments } from './useBootstrapExperiments.ts';

export const useCityCollectionsExperiment = (
  location: ComputedRef<{ isCity: boolean; isRegion: boolean; isCountry: boolean }>,
) => {
  const EXP_NAME = 'listing_city_collections2';
  const TARGET_EXP_VARIANT = 'without_collections';
  const { isExperimentVariantActive } = useBootstrapExperiments();

  const isExpActive = computed(() => {
    return isExperimentVariantActive(EXP_NAME, TARGET_EXP_VARIANT);
  });

  const isCollectionsHidden = computed(() => {
    return isExpActive.value && location.value.isCity;
  });

  watch(
    () => location.value.isCity,
    (isCity) => {
      if (isCity) {
        trackEvent('experiments.hit', {
          experiment: EXP_NAME,
          variant: isExpActive.value ? TARGET_EXP_VARIANT : 'original',
        });
      }
    },
    { immediate: true },
  );

  return { isCollectionsHidden };
};
